import React from 'react';
import { Check, X } from 'lucide-react';
import { whyPartnership } from '../../data/mock';

const Comparison = () => {
  return (
    <section className="py-16 lg:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-light text-stone-800 mb-6">
            {whyPartnership.title}
          </h2>
          <div className="w-20 h-px bg-amber-700/40 mx-auto" />
        </div>

        {/* Comparison cards */}
        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {whyPartnership.comparison.map((item, index) => (
            <div
              key={item.type}
              className={`rounded-2xl p-8 lg:p-10 card-hover ${
                item.isAcoe
                  ? 'bg-gradient-to-br from-stone-800 to-stone-900 text-stone-50 shadow-xl scale-[1.02]'
                  : 'bg-stone-100 text-stone-700 border border-stone-200'
              }`}
            >
              <div className="mb-6">
                {item.isAcoe && (
                  <span className="inline-block px-3 py-1 bg-amber-600/20 text-amber-300 text-xs tracking-wider uppercase rounded-full mb-4">
                    Our Model
                  </span>
                )}
                <h3 className={`text-xl font-medium ${
                  item.isAcoe ? 'text-stone-50' : 'text-stone-800'
                }`}>
                  {item.type}
                </h3>
              </div>
              
              <ul className="space-y-4">
                {item.points.map((point, pointIndex) => (
                  <li key={pointIndex} className="flex items-start gap-3">
                    <div className={`mt-0.5 flex-shrink-0 ${
                      item.isAcoe ? 'text-amber-400' : 'text-stone-400'
                    }`}>
                      {item.isAcoe ? (
                        <Check className="w-5 h-5" />
                      ) : (
                        <X className="w-5 h-5" />
                      )}
                    </div>
                    <span className={`text-base font-light ${
                      item.isAcoe ? 'text-stone-200' : 'text-stone-600'
                    }`}>
                      {point}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Comparison;
